/* eslint-disable react/prefer-stateless-function, react/no-direct-mutation-state */
import React from 'react';
import PropTypes from 'prop-types';
import './modal.css';

class Modal extends React.Component {
  constructor() {
    super();

    this.state = {
      isVisible: false,
    };
  }

  componentDidMount() {
    if (this.state.isVisible) {
      this.show();
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.visible !== this.state.isVisible) {
      this.state.isVisible = nextProps.visible;

      if (this.state.isVisible) {
        this.show();
      } else {
        this.hide();
      }
    }
  }

  show() {
    this.state.isVisible = true;
    this.dialog.showModal();
  }

  hide() {
    this.state.isVisible = false;
    this.dialog.close();
  }
  render() {
    this.state.isVisible = this.props.visible;

    return (
      // eslint-disable-next-line no-return-assign, arrow-parens
      <dialog className="dialog" ref={(ref) => (this.dialog = ref)}>
        {this.props.children}
      </dialog>
    );
  }
}

Modal.propTypes = {
  visible: PropTypes.bool.isRequired,
  children: PropTypes.node.isRequired,
};

export default Modal;



// WEBPACK FOOTER //
// ./src/components/Modal.jsx